var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./chat-invitation.j2"] = require( "./chat-invitation.j2" );
dependencies["./chat-widget-init.j2"] = require( "./chat-widget-init.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/chat/chat-widget.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.browseDisplayOptions.enableChat",false]));
frame.set("enableChat", t_1, true);
if(frame.topLevel) {
context.setVariable("enableChat", t_1);
}
if(frame.topLevel) {
context.addExport("enableChat", t_1);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "enableChat")) {
output += "\n    <div class=\"dom-chat-widget\">\n        ";
env.getTemplate("./chat-invitation.j2", false, "core/templates/chat/chat-widget.j2", null, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
t_2.render(context.getVariables(), frame, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
output += t_3
output += "\n        ";
env.getTemplate("./chat-widget-init.j2", false, "core/templates/chat/chat-widget.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n    </div>\n";
})})})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/chat/chat-widget.j2"] , dependencies)